/**
 * ローカルストレージを管理するクラス
 */
import Config from '../config/main.es6';


const STORAGE_DATA = {
    clearviewed: false,
    howtoViewed: false
}


export default class LStorage{
    

    constructor(){
        this.storageData = {};
        this.storageName = Config.STORAGE_KEY;
        this._init();
    }


    /**
     * データを取得する
     * @return {any} 指定したストレージデータの値
     */
    getData(key){
        if(this.storageData[key] == undefined) return null;
        return this.storageData[key];
    }


    /**
     * 指定データの上書き
     * @param key {string} データのキー
     * @param value {any} 上書きする値
     */
    setData(key, value){
        this.storageData[key] = value;
        localStorage.setItem(this.storageName, JSON.stringify(this.storageData));
    }


    /**
     * データを初期化する
     */
    reset(){
        this.storageData = STORAGE_DATA;
        localStorage.getItem(this.storageName, JSON.stringify(this.storageData));
    }


    _init(){
        this.storageData = JSON.parse(localStorage.getItem(this.storageName));

        // データがない場合は作成する
        if(!this.storageData){
            this.storageData = STORAGE_DATA;
            localStorage.setItem(this.storageName, JSON.stringify(this.storageData));
        }
    }
}